module.exports = __webpack_public_path__ + "static/img/Group 13401.0033753b.png";